import { NgModule } from '@angular/core';
import { ProCarouselComponent } from './pro-carousel/pro-carousel.component';
import { CommonModule } from '@angular/common';
import { VideoPlayerModule } from '../../../../shared/components/video-player/video-player.module';
import { ImgResizeModule } from '../../../../shared/components/img-resize/img-resize.module';
import { RouterModule } from '@angular/router';
import { KzCornerRibbonModule } from "../../../../kz-ui/ui/corner-ribbon/kz-corner-ribbon.module";
import { ProFavoriteComponent } from './pro-favorite/pro-favorite.component';
import { KzButtonModule } from '../../../../kz-ui/ui/form/button/kz-button.module';
import { UtilsModule } from '../../../../utils/utils.module';
import { KzIconsModule } from '../../../../kz-ui/ui/icon/kz-icons.module';
import { DiapoButtonModule } from '../../../../shared/components/diapo-button/diapo-button.module';
import { ClickAccessControlDirective } from '../../../../utils/directives/access-control.directive';

@NgModule({
  imports: [
    CommonModule,
    VideoPlayerModule,
    ImgResizeModule,
    RouterModule,
    KzCornerRibbonModule,
    KzButtonModule,
    UtilsModule,
    KzIconsModule,
    DiapoButtonModule,
    ClickAccessControlDirective,
  ],
  declarations: [
    ProCarouselComponent,
    ProFavoriteComponent
  ],
  exports: [
    ProCarouselComponent,
    ProFavoriteComponent
  ],
})
export class ProSharedModule {

}
